import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

/**
 * /auth/callback — Supabase OAuth redirect target.
 * Supabase client auto-exchanges code for session on mount (via onAuthStateChange).
 * This component waits for session then routes to `next` param (default /app).
 */
const AuthCallback: React.FC = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next') || '/app';

  useEffect(() => {
    if (isLoading) return;
    if (user) {
      navigate(next, { replace: true });
    } else {
      // No session — fallback to login after 2s (gives Supabase time to process hash tokens)
      const timer = setTimeout(() => navigate('/login', { replace: true }), 2000);
      return () => clearTimeout(timer);
    }
  }, [user, isLoading, navigate, next]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <svg className="w-8 h-8 text-indigo-500 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <span className="text-slate-500 text-sm font-medium">Đang xác thực...</span>
      </div>
    </div>
  );
};

export default AuthCallback;
